<ng-container
  *ngIf="
    (srcCoinSelectorOpened && isMobile) || (destCoinSelectorOpened && isMobile);
    else backButton
  "
>
  <div class="button-header btn-close" *ngIf="isGroup">
    <img src="/assets/icons/groups/close_white.svg" alt="Close" />
    <button class="td-btn">Cerrar</button>
  </div>
</ng-container>
<ng-template #backButton>
  <div class="button-header" *ngIf="isGroup" [routerLink]="'/grupos'" routerLinkActive="active">
    <img src="/assets/icons/dca/arrow-back.svg" alt="back" />
    <button class="td-btn">Volver</button>
  </div>
</ng-template>

<div
  class="main-swap-container"
  [ngClass]="{
    'mobile-group': isMobile && isGroup
  }"
>
  <div class="swap-card">
    <div class="swap-card-header">
      <p class="header-title">Swap</p>
    </div>
    <div class="swap-card-body">
      <div class="exchange-container">
        <div class="input-container">
          <div class="row">
            <div class="coin-selector" (click)="openCoinSelector(0); $event.stopPropagation()">
              <img
                *ngIf="srcCoin"
                class="coin-icon"
                [src]="'/assets/icons/crypto/' + srcCoin.toLowerCase() + '.svg'"
                alt="coin"
              />
              <p class="coin-ticker">{{ srcCoin }}</p>
              <img class="expand-icon" src="/assets/icons/expand.svg" alt="expand" />
            </div>
            <div
              class="coin-selector-content"
              *ngIf="srcCoinSelectorOpened"
              [ngClass]="{
                'coin-selector-width': isGroup
              }"
              (click)="$event.stopPropagation()"
            >
              <input
                type="text"
                *ngIf="isGroup"
                (keyup)="search()"
                placeholder="Buscar criptomoneda"
                [formControl]="searchValue"
                #inputSearch
              />
              <img
                *ngIf="isGroup"
                class="search"
                src="/assets/icons/search_swap.svg"
                alt="search"
              />
              <div
                [ngClass]="{
                  'coin-selector-group': isGroup
                }"
              >
                <div
                  *ngFor="let coin of availableCoins | filterCoinsSwap : page : limit : isGroup"
                  class="coin-option"
                  (click)="selectCoin(0, coin)"
                >
                  <img [src]="'/assets/icons/crypto/' + coin.toLowerCase() + '.svg'" alt="coin" />
                  <div class="option-row">
                    <p>{{ coin }}</p>
                  </div>
                </div>
              </div>
              <div class="container-filter" *ngIf="isGroup">
                <div class="buttons">
                  <button mat-button (click)="prevPage()">&nbsp;</button>
                  <p
                    class="current-page"
                    *ngFor="let p of [].constructor(updatePages); let i = index"
                    [class.active]="current === i"
                    (click)="checkPage(pageNumber + i, i)"
                  >
                    {{ pageNumber + i }}
                  </p>
                  <button mat-button class="next" (click)="nextPage()">&nbsp;</button>
                </div>
              </div>
            </div>
            <p class="max-btn" (click)="setMaxSrcCoinBalance()">MAX</p>
            <input
              type="text"
              placeholder="0,00"
              thousandSeparator="."
              decimalMarker=","
              [mask]="cryptoService.isStableCoin(srcCoin) ? 'separator.3' : 'separator.5'"
              [formControl]="srcValueControl"
              (keyup)="syncAmount(1)"
            />
          </div>
          <p class="balance" *ngIf="cryptoBalances">
            Balance: {{ cryptoBalances[srcCoin] || 0 | formatCoinAmount : srcCoin }} {{ srcCoin }}
          </p>
        </div>
        <div class="input-container">
          <div class="row">
            <div class="coin-selector" (click)="openCoinSelector(1); $event.stopPropagation()">
              <img
                *ngIf="destCoin"
                class="coin-icon"
                [src]="'/assets/icons/crypto/' + destCoin.toLowerCase() + '.svg'"
                alt="coin"
              />
              <p class="coin-ticker">{{ destCoin }}</p>
              <img class="expand-icon" src="/assets/icons/expand.svg" alt="expand" />
            </div>
            <div
              class="coin-selector-content"
              *ngIf="destCoinSelectorOpened"
              (click)="$event.stopPropagation()"
              [ngClass]="{
                'coin-selector-width': isGroup
              }"
            >
              <input
                type="text"
                *ngIf="isGroup"
                (keyup)="search()"
                placeholder="Buscar criptomoneda"
                [formControl]="searchValue"
                #inputSearch
              />
              <div
                [ngClass]="{
                  'coin-selector-group': isGroup
                }"
              >
                <div
                  *ngFor="let coin of availableCoins | filterCoinsSwap : page : limit : isGroup"
                  class="coin-option"
                  [class.disabled]="
                    cryptoService.getValidSwapPair(srcCoin, coin) === '' &&
                    srcCoin !== destCoin &&
                    !isGroup
                  "
                  [class.disappear]="
                    (srcCoin === coin && !isGroup) || coin === 'LUNA' || coin === 'UST'
                  "
                  (click)="srcCoin !== coin && selectCoin(1, coin)"
                >
                  <img [src]="'/assets/icons/crypto/' + coin.toLowerCase() + '.svg'" alt="coin" />
                  <div class="option-row">
                    <p>{{ coin }}</p>
                    <span
                      *ngIf="cryptoService.getValidSwapPair(srcCoin, coin) === '' && !isGroup"
                      class="comming-soon-text"
                      >Próximamente</span
                    >
                  </div>
                </div>
              </div>
              <div class="container-filter" *ngIf="isGroup">
                <div class="buttons">
                  <button mat-button (click)="prevPage()">&nbsp;</button>
                  <p
                    class="current-page"
                    *ngFor="let p of [].constructor(updatePages); let i = index"
                    [class.active]="current === i"
                    (click)="checkPage(pageNumber + i, i)"
                  >
                    {{ pageNumber + i }}
                  </p>
                  <button mat-button (click)="nextPage()" class="next">&nbsp;</button>
                </div>
              </div>
            </div>
            <input
              type="text"
              placeholder="0,00"
              [mask]="cryptoService.isStableCoin(destCoin) ? 'separator.3' : 'separator.5'"
              thousandSeparator="."
              decimalMarker=","
              [formControl]="destValueControl"
              (keyup)="syncAmount(0)"
            />
          </div>
          <p class="balance">
            Balance:
            {{ cryptoBalances[destCoin] || 0 | formatCoinAmount : destCoin }} {{ destCoin }}
          </p>
        </div>
        <div class="coin-switcher" (click)="switchCoins()">
          <img src="/assets/icons/sidebar/swap.svg" alt="swap" />
        </div>
      </div>
      <p class="price-text">
        1 {{ currentCoinPair.split('_')[0] }} ≈
        {{
          isGroup
            ? (srcCoin === 'BTC' || srcCoin === 'ETH') && quoteCoins[destCoin] && destCoin !== 'ETH'
              ? (currentPrice?.sell | number : '0.3-8')
              : ((quoteCoins[srcCoin] ? currentPrice?.buy : currentPrice?.sell) | number : '0.3-8')
            : ((cryptoService.isBuyingSwapPair(srcCoin, destCoin)
                ? currentPrice?.buy
                : currentPrice?.sell
              ) | number : '0.3-3')
        }}
        {{ currentCoinPair.split('_')[1] }}
      </p>
      <div class="btn-mobile">
        <button
          *ngIf="!isProcessing; else trxProcessing"
          class="swap-button"
          [class.disabled]="!checkSwapAvailable()"
          (click)="swapBtnClicked()"
        >
          {{ getButtonText() }}
        </button>
      </div>
      <ng-template #trxProcessing>
        <div class="loading">
          <div class="circle-loader">
            <div class="checkmark draw"></div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
